<template>
  <div class="app-container">
    <navigation title="一卡通"></navigation>
    <div class="cartoon-card">
      <div class="card-cont">
      <ul>
        <li class="card-num">卡号：{{ $store.state.rcardId }}</li>
        <li class="card-money">¥<span class="money-num">{{ $store.state.balance }}</span></li>
      </ul>
    </div>
    </div>
    <version type="position"></version>
  </div>
</template>

<script>
import Vue from 'vue'
import navigation from '../../components/navigation'
import { Tabbar, TabbarItem, NavBar, Cell, CellGroup } from 'vant'
import version from '../../components/version'

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup)

export default {
  name: 'cartoon',
  components: {navigation, version},
  data () {
    return {
      active: 3
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.app-container{
  padding-top:.92rem;
}
.cartoon-card{
  width:100%;
  height: 13.7rem;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: 100%;
  position: relative;
  font-size:.28rem;
  font-family: SourceHanSerifCN-SemiBold;
}
.card-cont{
  width:6.59rem;
  height:3.37rem;
  padding-top:.64rem;
  margin-right:.45rem;
  margin-left: .46rem;
}
.card-cont ul{
  width: 6.59rem;
  height:3.37rem;
  background-size:100% 100%;
  position:relative;
  border-radius: .16rem;
}
.card-num{
  font-size:.28rem;
  padding:.36rem  0 0 .33rem;
}
.card-money{
  text-align:center;
  font-size:.36rem;
}
.card-money{
  text-align:center;
  font-size:.36rem;
  line-height:1.6rem;
}
.money-num{
  font-size:.72rem;
}
</style>



// WEBPACK FOOTER //
// src/view/cartoon/index.vue